<template>
    <crud-facecade
        ref="message-list"
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :addButton="{ enabled: false, permission: 'default' }"
        :deleteButton="{ enabled: true, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
        @rowClick="activRow"
    ></crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `MessageReceive`,
    props: {

    },
    data() {
        return {
            title: `消息接收`,
            url: { baseURL: `/api/Operation/MessageReceive/`,
                get: () => {
                    return this.loadMessage()
                },
                delete: (row) => {
                    return this.myaxios.post(`/api/Operation/MessageReceive/Delete`, [row.id])
                } },
            buttons: [],
            users: []
        }
    },
    created() {
        this.loadUsers()
    },
    computed: {
        ...mapGetters([`sys_enums`]),
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isKey: true
            }, {
                type: `datetime`,
                prop: `receive_date`,
                label: `时间`,
                width: `140`,
                isListable: true
            }, {
                type: `select`,
                prop: `sender`,
                label: `发送人`,
                width: `160`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                options: this.users
            }, {
                type: `string`,
                prop: `title`,
                label: `标题`,
                width: `200`,
                isListable: true,
                isEditable: true,
                isCreatable: true
            }, {
                type: `textarea`,
                prop: `content`,
                label: `内容`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                config: {
                    minRows: 6,
                    maxRows: 6,
                    align: `left`
                }
            }]
        }
    },
    mounted() {

    },
    methods: {
        activRow({ row }) {
            if (!row.is_read) {
                let url = row.ac_sys_user_id == 0 ? `&ac_SysUser_Id=0` : ``
                let req = this.myaxios.get(`/api/Operation/MessageReceive/UpdateReadReceive?biz_messageheader_id=${row.biz_message_header_id}${url}`)
                req.then((data) => {
                    this.$refs[`message-list`].ReloadListData()
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then((data) => {
                this.users = _.map(data, d => {
                    return {
                        value: d.username,
                        label: d.dic_worker_name || `--`,
                        code: d.username,
                        disabled: d.is_deleted
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadMessage() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Operation/MessageReceive/Get`, { from: this.$moment().add(`days`, -30).format(`YYYY/MM/DD HH:mm`), to: this.$moment().format(`YYYY/MM/DD HH:mm:ss`) })
                req.then(data => {
                    let r = data && _.filter(data, d => d.biz_message_content && d.biz_message_content.enum_message_status !== 2).map(d => {
                        return {
                            id: d.id,
                            receive_date: d.receive_date,
                            ac_sys_user_id: d.ac_sys_user_id,
                            sender: d.biz_message_content.modifier,
                            title: d.biz_message_content.title,
                            is_read: d.is_read,
                            biz_message_header_id: d.biz_message_header_id,
                            content: d.is_read ? `[已读]${d.biz_message_content.content}` : d.biz_message_content.content,
                            cell_class: { content: !d.is_read ? `unRead` : `` }
                        }
                    })
                    resolve(r)
                }).catch(e => reject(e))
            })
        }
    }
}
</script>
<style  lang="less">
.unRead {
    .textarea {
        &::before {
            content: '';
            background: red;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: relative;
            margin-right: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Message/MessageReceive.vue